import { reportPlanSummaryMap } from "@ishvaram/domain-data/report-plan-summaries";
import type { PremiumReportPlanId } from "@ishvaram/domain-data/report-plans";

/**
 * Lightweight commerce summary for client-side acquisition surfaces.
 *
 * Do not import `reports-content` here: that module owns the full SEO/PDP copy
 * catalog. Pulling it into a Client Component duplicates every report's long
 * sales copy across route chunks whenever the catalog grows. Commerce name and
 * price already have a canonical generated source in domain-data.
 */
export function reportPlanSummaryById(
  planId: string,
  language: "en" | "hi" = "en"
): { name: string; priceInr: number } | null {
  const plan = reportPlanSummaryMap[planId as PremiumReportPlanId];
  if (!plan) return null;
  return { name: language === "hi" ? plan.name_hi : plan.name, priceInr: plan.price_inr };
}
